import axios from 'axios';
import { getMicroServiceUrl } from '../helpers/helpers';
import { generalData } from './general';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
export const getChallenges = (id) => ({
  type: 'GET_ALL_CHALLENGES',
  payload: axios.get(
    `${getMicroServiceUrl('gamification', '2.0')}orgPropertyId/${id}/challenges`
  ),
});

export const getChallengeCategory = (id, cat) => ({
  type: 'GET_CHALLENGES_CATEGORY',
  payload: axios.get(
    `${getMicroServiceUrl(
      'gamification',
      '2.0'
    )}orgPropertyId/${id}/challenges/category/${cat}`
  ),
});

export const getOffers = (id) => ({
  type: 'GET_OFFERS',
  payload: axios.get(
    `${getMicroServiceUrl(
      'gamification',
      '2.0'
    )}orgPropertyId/${id}/challenges/category/offers`
  ),
});

export const postLeakRepairSignup = (
  data,
  taskTag,
  taskId,
  propertyId,
  onSuccess
) => {
  const userData = {
    taskTag: `${taskTag}`,
    taskId,
    propertyId,
    data: {
      ...data,
    },
  };

  return (dispatch) => {
    const response = dispatch({
      type: 'POST_TASK_DATA',
      payload: axios.post(
        `${getMicroServiceUrl('user-content')}task-data`,
        userData
      ),
    });

    response
      .then(() => {
        dispatch(getChallengeCategory(data.id, 'offers'));
        dispatch({ type: 'LEAK_FIX_SIGNUP' });
      })
      .catch((err) => {
        toast.error(_.get(err, 'data.errors', 'Something has gone wrong'), {
          autoClose: 5000,
        });
      });
  };
};

export const completeChallenge = (id, challengeId) => {
  return (dispatch) => {
    const response = dispatch({
      type: 'COMPELTE_CHALLENGE',
      payload: axios.post(
        `${getMicroServiceUrl(
          'gamification',
          '2.0'
        )}orgPropertyId/${id}/challenges/${challengeId}/complete`
      ),
      meta: {
        id,
      },
    });
    response
      .then((data) => {
        setTimeout(() => {
          dispatch(generalData());
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
